<template>
  <div class="myGoogleMap">
    <b-modal
      title="Choose period"
      class="modal-primary"
      v-model="modalDate"
      @ok="fetchMarkers(), (modalDate = false)"
    >
      <b-form>
        <b-form-group label="From" label-for="date" :label-cols="3">
          <datepicker use-utc
            format="MM/dd/yyyy"
            :bootstrap-styling="true"
            v-model="dateFrom"
            name="dateFrom"
          ></datepicker>
        </b-form-group>
        <b-form-group label="To" label-for="dateTo" :label-cols="3">
          <datepicker use-utc
            format="MM/dd/yyyy"
            :bootstrap-styling="true"
            v-model="dateTo"
            name="dateTo"
          ></datepicker>
        </b-form-group>
      </b-form>
    </b-modal>

    <b-card-header style="">
      <!--      <b> User: </b>-->
      <!--      <b-form-select-->
      <!--        v-model="selected"-->
      <!--        :options="options"-->
      <!--        style="width:170px"-->
      <!--        value-field="item"-->
      <!--        @change="fetchMarkers()"-->
      <!--        text-field="name"-->
      <!--      ></b-form-select>-->

      <b-button
        @click="modalDate = true"
        class
        style="height: 26px; width: 26px; "
        variant="transparent p-0"
      >
        <i class="icon-calendar" style="color: #20a8d8;"></i>
      </b-button>

      <span
        style="float:right; line-height:30px; margin-right:20px; color:rgb(32, 168, 216)"
      >
        {{ from ? from : dateFrom }}
        <b>|</b>
        {{ to ? to : dateTo }}
      </span>
    </b-card-header>

    <div
      style="height: 400px; padding-top: 150px"
      v-if="loading"
      class="loading"
    >
      <b-row>
        <b-col lg="12">
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>
        </b-col>
      </b-row>
      <!--/.row-->
    </div>
    <gmap-map
      v-if="!loading"
      :center="center"
      :options="mapOptions"
      style="width:100%;  height: 90vh;"
    >
      <gmap-info-window
        class="mapWindow"
        :options="infoOptions"
        :position="infoPosition"
        :opened="infoOpened"
        @closeclick="infoOpened = false"
      >
        <div :key="key" v-for="(item, key) in cityNum">
          <h4>{{ item.data[0].user }}</h4>
          <br />
          <span>Date: {{ item.data[0].date }}</span>
          <br />
          <span>City: {{ item.data[0].city }}</span>
          <br />
          <hr />
          <span>{{ item.data[0].issue }}</span>
          <hr />
          <b-button
            variant="outline-primary"
            @click="() => $router.push('/issue/?id=' + item.data[0].id)"
            style="display:block; margin:auto;  margin-top:10px; height:40px; width:130px"
            >Open</b-button
          >
        </div>

        <!-- <q-item exact class="side-menu" style="cursor: pointer">
          <img style=" border-radius: 50px;width: 150px; height: 150px;" :src="infoPicture" />
        </q-item>-->
      </gmap-info-window>

      <GmapMarker
        v-for="(m, index) in table"
        :key="index"
        :ref="`marker${index}`"
        :position="getPosition(m)"
        @click="toggleInfo(m, index)"
        :icon="
          m[6]
            ? 'https://www.fibernode.com/oem-portal/img/' + m[6] + 'dot.png'
            : 'https://www.fibernode.com/oem-portal/img/mapgmarker.png'
        "
      />
    </gmap-map>
  </div>
</template>

<script>
import GmapCustomMarker from "vue2-gmap-custom-marker";
import router from "../../router";
//const mapMarker = ('/img/mapgmarker.png');
import Datepicker from "vuejs-datepicker";
import { allowedPath } from "../../shared/utils";

export default {
  name: "IssueMap",
  components: {
    router,
    GmapCustomMarker,
    Datepicker
  },
  data() {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      loading: true,
      mapOptions: {
        zoom: 5,
        streetViewControl: false,
        mapTypeControl: false
      },
      center: { lat: 41.881832, lng: -87.6254 },
      table: [],
      stateDateFrom: "",
      markerOptions: {
        url: "https://www.fibernode.com/oem-portal/img/mapgmarker.png",
        size: { width: 20, height: 20, f: "px", b: "px" },
        scaledSize: { width: 20, height: 20, f: "px", b: "px" }
      },
      selected: "All",
      options: [],
      stateDateTo: "",
      cityNum: null,
      solved: "",
      thisLat: null,
      modalDate: false,
      thisLng: null,
      infoPosition: null,
      infoCty: null,
      infoMny: null,
      infoCompany: null,
      infoPicture: null,
      infoOpened: false,
      infoQty: null,
      infoCurrentKey: null,
      dateFrom: "",
      dateTo: "",
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    };
  },

  mounted() {
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.stateDateFrom = fromDate.toJSON().slice(0, 10);
    this.stateDateTo = new Date().toJSON().slice(0, 10);
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.fetchSalesReps();
    this.fetchMarkers();
  },
  // iz nekog razloga pri lokaciji moram dodati %282%29 da bi ucitalo, nisam siguran sto?
  methods: {
    fetchSalesReps() {
      this.$http.get("api/fns/sales/salesRepList.php").then(
        res => {
          console.log(res.data);
          this.options = res.data;
        },
        err => {
          console.log(err);
        }
      );
    },
    sendSolved(id) {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("solved", this.solved);
      this.$http
        .post("api/fns/issues/solvedIssue.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(
          res => {
            console.log(res);
            this.fetchMarkers();
          },
          err => {
            console.log(err);
          }
        );
    },
    openData(loc, city, lat, lng) {
      router.push(
        "/base/city/?loc=" +
          loc +
          "&city=" +
          city +
          "&lat=" +
          lat +
          "&lng=" +
          lng
      );
    },
    fetchMarkers() {
      this.loadingState = true;
      let params = {
        date_from: this.dateFrom,
        date_to: this.dateTo,
        user: this.selected
      };
      this.$http
        .get("api/fns/issues/IssueMapPreview.php", {
          params
        })
        .then(
          res => {
            this.table = res.data.records;
            console.log("EVOGA:" + this.table);
            this.loading = false;
          },
          err => {
            console.log(err);
            this.loading = false;
          }
        );
    },
    getPosition: function(marker) {
      return {
        lat: parseFloat(marker[3]),
        lng: parseFloat(marker[4])
      };
    },

    toggleInfo: function(marker, key) {
      console.log(marker);
      var result = { city: [] };
      var jsonObj;

      this.table.forEach((value, index) => {
        if (marker[3] == value[3] && marker[4] == marker[4]) {
          console.log(value);
          jsonObj = {
            data: [
              {
                user: value[0],
                date: value[1],
                city: value[2],
                issue: value[5],
                id: value[7]
              }
            ]
          };
          result.city.push(jsonObj);
        }
      });
      this.infoPosition = this.getPosition(marker);
      this.infoCty = marker[0];
      this.cityNum = result.city;
      this.infoQty = marker[2];
      this.infoMny = marker[3];
      this.thisLat = marker[4];
      this.thisLng = marker[5];

      if (this.infoCurrentKey === key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }
    }
  },
  computed: {
    from() {
      if (typeof this.dateFrom === "object") {
        this.dateFrom = this.dateFrom.toISOString().split("T")[0];
        return this.dateFrom;
      }
    },
    to() {
      if (typeof this.dateTo === "object") {
        this.dateTo = this.dateTo.toISOString().split("T")[0];
        return this.dateTo;
      }
    }
  }
};
</script>
<style scoped>
.myGoogleMap {
  margin-top: -17px !important;
  margin-right: -30px;
  margin-left: -30px;
}
</style>
<style>
.gm-style .gm-style-iw-d {
  color: black !important;
}
.gm-style .gm-style-iw-d span {
  font-size: 1.1em;
}
.gm-style .gm-style-iw-d b {
  font-size: 1.1em;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.vdp-datepicker .input-group input {
  background: #515b65 !important;
}
</style>
